var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDies16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9945 19H13.901L14.7767 15.1677H17.6144L17.9691 13.5281H15.1536L15.9074 10.3167H18.6453L19 8.68676H16.2953L17.1489 5H15.2534L14.3777 8.68676H10.9747L11.8171 5H9.9327L9.05701 8.68676H6.38559L6.00871 10.3167H8.68013L7.94854 13.5281H5.3658L5 15.1677H7.56057L6.68488 19H8.56928L9.45606 15.1677H12.8812L11.9945 19ZM9.75534 13.6057L10.5313 10.2488H14.0895L13.3025 13.6057H9.75534Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDies16);
export default __webpack_public_path__ + "static/media/ico-dies-16.8fcb8d8c.svg";
export { ForwardRef as ReactComponent };